import {GetCoinsResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coins/v1/service.types';
import {useTranslation} from '@aboutyou/i18n';
import {Fade} from '@aboutyou/transitions';
import {
  GenericIconName,
  HEADER_BUTTON_FADE_DURATION,
  HeaderButton,
  Icon,
} from '@aboutyou/ui-components';
import React from 'react';
import {OffcanvasButton} from '../../Navigation/Components/OffcanvasHeaderComponents';
import {useWalletStateManager} from '../../Wallet/utils/useWalletStateManager';

export const HeaderCoinsWalletButtonView: React.FC<GetCoinsResponse> = ({
  availability,
}) => {
  const {t} = useTranslation();
  const {open} = useWalletStateManager();
  const ariaLabel = t('Open coins wallet');

  const handleOnClick = () => {
    open('coins');
  };

  if (availability?.$case === 'unavailable') {
    return null;
  }

  return (
    <Fade mounted={true} duration={HEADER_BUTTON_FADE_DURATION}>
      {process.env.STACK === 'desktop' ? (
        <HeaderButton
          data-testid="HeaderCoinsWalletButton"
          asset={GenericIconName.Coins}
          iconSize="S"
          onClick={handleOnClick}
          aria-label={ariaLabel}
        />
      ) : (
        <OffcanvasButton
          disableShadow
          onClick={handleOnClick}
          data-testid="HeaderCoinsWalletButton"
          aria-label={ariaLabel}
        >
          <Icon asset={GenericIconName.Coins} size="S" />
        </OffcanvasButton>
      )}
    </Fade>
  );
};
